import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { Checkbox } from '../../../../components/ui/Checkbox';
import { PreflightSection } from './PreflightSection';

interface WpsAlreadyInFileProps {
  names: string[];
  refused: boolean;
  monthName: string;
  year: number;
  confirmed: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
}

/**
 * UAE, in the wizard's pre-flight: people this run would regenerate who are in an active WPS file. Every name shows,
 * because a pre-flight that lists a different set from the run is worse than none. Warn asks for a tick; Refuse is a
 * blocker the page already reads from hasBlockers. It points to a next-month adjustment or the correction, never to Void.
 */
export const WpsAlreadyInFile: React.FC<WpsAlreadyInFileProps> = ({ names, refused, monthName, year, confirmed, onConfirmedChange }) => {
  const { t } = useTranslation();
  if (names.length === 0) return null;
  return (
    <PreflightSection
      icon={AlertTriangle}
      tone={refused ? 'error' : 'warn'}
      title={t('payroll.wps.uae.inFile.title', { month: monthName, year })}
      count={names.length}
      names={names}
      listEveryName
      footnote={refused ? t('payroll.wps.uae.inFile.refused') : t('payroll.wps.uae.inFile.warn')}
      testId="preflight-already-in-file"
    >
      {!refused && (
        // Load-bearing `relative`: the checkbox's input is sr-only and this sits inside the dialog's inner scroller.
        <div className="relative mt-2">
          <Checkbox
            label={t('payroll.wps.uae.inFile.tick')}
            checked={confirmed}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onConfirmedChange(e.target.checked)}
            data-testid="preflight-already-in-file-tick"
          />
        </div>
      )}
    </PreflightSection>
  );
};
